import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from '../app-insights.service';
import { environment } from 'src/environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IReinstateLedger } from 'src/app/Shared/models/Reinstate';
import { ISaveDeleteResponse, IEmailNotificationFilter, IRecieveEmailListResponse, IMarkAsReadEmail, IMarkAsReadEmailResponse, IEmailDetail, IMarkEmailRead, IMarkAllEmailsRead } from 'src/app/Shared/interface';
import { IEmailBodyInput } from 'src/app/Shared/interface2';
import { IEmailObject, IEmaiLogsList } from 'src/app/Shared/models/EmailSMS';
import {AppService} from '../app.service';


@Injectable({
    providedIn: 'root',
})

export class EmailAndSMSService {
    private baseURL = this.appService.config.apiBaseUrl;
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    composeEmail(emailObjList: IEmailObject[]): Observable<ISaveDeleteResponse[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/EmailAndSMS/ComposeEmails`;
        return this.http.post<ISaveDeleteResponse[]>(url, emailObjList, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    composeSMS(smsObjList): Observable<ISaveDeleteResponse[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/EmailAndSMS/CreateSMS`;
        return this.http.post<ISaveDeleteResponse[]>(url, smsObjList, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SendEmailToReputationManagement(data): Observable<ISaveDeleteResponse[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/ReputationManagement/SendEmailToReputationManagement`;
        return this.http.post<ISaveDeleteResponse[]>(url, data, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getEmailLogsList(tenantId: number): Observable<IEmaiLogsList[]> {
        return this.http.get<IEmaiLogsList[]>(
            `${this.baseURL}/EmailAndSMS/GetAllEmailLogs?tenantId=${tenantId}`,
        { observe: 'response' }).pipe(
            map(res => {
                return res.body as IEmaiLogsList[];
            }),
            catchError(this.handleError)
        );
    }

    refreshEmailStatus(emailLogId: number): Observable<string> {
        return this.http.post(
            `${this.baseURL}/EmailAndSMS/RefreshEmailStatus?emailLogId=${emailLogId}`,
            {}, 
            { responseType: 'text' } 
        ).pipe(
            catchError(this.handleError)
        );
  }
  GetIncomingEmailList(request: IEmailNotificationFilter): Observable<IRecieveEmailListResponse[]> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/EmailAndSMS/GetReceivedEmailList`;
    return this.http.post<IRecieveEmailListResponse[]>(url, request, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  deleteemail(markReadInput: IMarkAsReadEmail): Observable<IMarkAsReadEmailResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/EmailAndSMS/MarkEmailNotificationRemoved`;
    return this.http.post<IMarkAsReadEmailResponse>(url, markReadInput, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  GetEmails(Id: string): Observable<IEmailBodyInput> {
    return this.http.get<IEmailBodyInput>(
      `${this.baseURL}/EmailAndSMS/GetEmails?Id=${Id}`,
      { observe: 'response' }).pipe(
        map(res => {
          return res.body as IEmailBodyInput;
        }),
        catchError(this.handleError)
      );
  }

  SaveEmails(emailsLogModel): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/EmailAndSMS/SaveEmails`;
    return this.http.post<ISaveDeleteResponse>(url, emailsLogModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  markEmailAsRead(model: IMarkEmailRead): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/EmailAndSMS/MarkEmailAsRead`, model, options)
      .pipe(catchError(this.handleError));
  }

  markAllEmailsAsRead(model: IMarkAllEmailsRead): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/EmailAndSMS/MarkAllEmailsAsRead`, model, options)
      .pipe(catchError(this.handleError));
  }

  getEmailById(emailLogId: number): Observable<IEmailDetail> {
    return this.http.get<IEmailDetail>(`${this.baseURL}/EmailAndSMS/GetEmailById?emailLogId=${emailLogId}`)
      .pipe(catchError(this.handleError));
  }

  removeEmailLink(emailLogId: number, facilityId: number): Observable<ISaveDeleteResponse> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<ISaveDeleteResponse>(`${this.baseURL}/EmailAndSMS/RemoveEmailLink`, { Id: emailLogId, FacilityId: facilityId }, options)
      .pipe(catchError(this.handleError));
  }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
